import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { Utils } from 'sharedGuiSmall/utils/utils';

@Injectable()
export class SignupInterceptor implements HttpInterceptor {

    idSrvUrl = window.idSrvUrl

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.headers.get('skipInterceptor')) {
            const cleanReq = req.clone({
                headers: req.headers.delete('skipInterceptor') // Remove flag before sending
            });
            return next.handle(cleanReq);
        }

        let conversationId = window.localStorage.getItem('ConversationId') ?? '';

        // Set new ConversationId
        if (!conversationId) {
            Utils.checkConversationId();
            conversationId = window.localStorage.getItem('ConversationId') ?? '';
        }

        if (req.url.includes('/assets/lang/')) {
            return next.handle(req); // Bypass the interceptor for translation requests
        }

        // Clone origin request
        if (req.url !== (this.idSrvUrl + '/connect/token')) //interceptor overwrites Authorization header on token request
            req = req.clone({
                // Add ConversationId header
                setHeaders: {
                    'ConversationId': conversationId ? conversationId : '',
                    'Authorization': 'Bearer ' + localStorage.getItem("accessToken") ?? ''
                },
                responseType: 'text'
            });

        if (req.url.includes(window.appPath)) {
            req = req.clone({
                setHeaders: {
                    'X-XSRF-Token': (<HTMLInputElement>document.getElementsByName('__RequestVerificationToken')[0]).value
                }
            });
        }
        return next.handle(req);
    }
}
